import { explainDeviceError } from "@/lib/iot/device-errors";

/**
 * A device error in an error notice: what happened, what to check (in the protocol's own
 * terms), and the gateway's own words under Details. A message that isn't a device error
 * shows as it is.
 */
export function DeviceErrorText({ message, driver }: { message: string; driver?: string }) {
  const problem = explainDeviceError(message, driver);
  if (!problem) return <span className="text-on-surface-muted">{message}</span>;
  return (
    <span className="flex flex-col gap-1">
      <span className="font-medium text-on-surface">{problem.title}</span>
      {problem.hint && <span className="text-on-surface-muted">{problem.hint}</span>}
      <details className="text-xs text-on-surface-muted">
        <summary className="cursor-pointer select-none">Details</summary>
        <code className="mt-1 block whitespace-pre-wrap break-all font-mono">{problem.raw}</code>
      </details>
    </span>
  );
}
